module.exports = __webpack_public_path__ + "static/media/@Kaveh Hashtroodi.290e26f5.png";